/* ZK Mystery Pack - updates the "1 tattoo costs" line when a pack is selected. */
(function () {
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.classList || !r.classList.contains('zk-mp__radio')) return;
    var root = r.closest('.zk-mp');
    var box = root && root.querySelector('[data-unit]');
    if (!box) return;
    var now = box.querySelector('[data-unit-now]');
    var was = box.querySelector('[data-unit-was]');
    var f = box.querySelector('[data-unit-f]');
    var uw = r.getAttribute('data-unit-was') || '';
    if (now) now.textContent = r.getAttribute('data-unit-now') || '';
    if (was) { was.textContent = uw; was.hidden = !uw; }
    if (f) f.textContent = r.getAttribute('data-unit-f') || '';
    box.hidden = !r.getAttribute('data-unit-now');
    if (now && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      now.classList.remove('zk-mp__bump');
      void now.offsetWidth;
      now.classList.add('zk-mp__bump');
    }
  });
})();